import { DateTime } from 'luxon';
import { DEFAULT_TIMEZONE, parseUTCDate } from '@/utils/dateHelpers';

// Parsea un string UTC de la base de datos a DateTime de Luxon
// Backend devuelve fechas en formato UTC: "2026-01-25 18:30:00"
const parseLocalDateTime = (datetime, timezone = DEFAULT_TIMEZONE) => {
  if (!datetime) return null;
  
  // Usar parseUTCDate para interpretar como UTC y convertir a timezone
  return parseUTCDate(datetime, timezone);
};

// Formatea una fecha y hora en el formato "Lunes 1 de Diciembre - 14:30 hrs"
// Ahora con soporte de zonas horarias usando Luxon
const formatFechaHoraEvento = (fechaHora, timezone = DEFAULT_TIMEZONE) => {
  console.log("formatFechaHoraEvento received fechaHora:", fechaHora, "timezone:", timezone);
  
  if (!fechaHora) return "Fecha no disponible";
  
  let dt;
  
  // Determinar si es un string, Date, o DateTime
  if (typeof fechaHora === 'string') {
    // Backend devuelve UTC, usar parseUTCDate para convertir
    dt = parseUTCDate(fechaHora, timezone);
  } else if (fechaHora instanceof Date) {
    // Convertir Date nativo a DateTime
    dt = DateTime.fromJSDate(fechaHora);
    // Si se especificó timezone, ajustar
    if (timezone) {
      dt = dt.setZone(timezone);
    }
  } else if (fechaHora instanceof DateTime) {
    // Ya es DateTime
    dt = fechaHora;
    // Si se especificó timezone diferente, ajustar
    if (timezone && dt.zoneName !== timezone) {
      dt = dt.setZone(timezone);
    }
  } else {
    return "Fecha no disponible";
  }
  
  if (!dt || !dt.isValid) {
    console.error("DateTime inválido:", dt?.invalidReason);
    return "Fecha no disponible";
  }
  
  // Formatear usando Luxon en español
  dt = dt.setLocale('es');
  
  const diaSemana = dt.toFormat('cccc'); // Nombre completo del día
  const dia = dt.day;
  const mes = dt.toFormat('MMMM'); // Nombre completo del mes
  const hora = dt.toFormat('HH:mm'); // Hora en formato 24h
  
  const cap = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  
  return `${cap(diaSemana)} ${dia} de ${cap(mes)} - ${hora} hrs`;
};

// Función para hacer scroll al top del main content
const scrollToTop = () => {
  const MainContent = document.getElementById("main-content");
  MainContent.scrollTo({ top: 0, behavior: "smooth" });
};
export { formatFechaHoraEvento, parseLocalDateTime, scrollToTop };
